<template>
  <v-column-avatar
    :label="labelBackup"
    avatar-key="administrator_avatar"
    nickname-key="administrator_nickname"
    :align="align"
    :width="width"
  />
</template>

<script>
export default {
  props: {
    label: String,
    align: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '132',
    },
  },
  data: () => ({
    labelBackup: '',
  }),
  beforeMount() {
    this.labelBackup = this.label || '操作者';
  }
};
</script>
